import { Injectable, inject } from '@angular/core';
import {
  addMonths,
  endOfMonth,
  endOfYear,
  getDaysInMonth,
  getMonth,
  getYear,
  parseISO,
  startOfMonth,
  startOfYear,
} from 'date-fns';
import { SiaDateService } from './date.service';
import { SiaNewRouterService } from './new-router.service';
import { SiaSessionService } from './session.service';
import { SiaSizeDetectorService } from './size-detector.service';
import { SiaUsersService } from './users.service';
@Injectable({
  providedIn: 'root',
})
export class SiaDefaultsService {
  private dateService = inject(SiaDateService);
  private sessionService = inject(SiaSessionService);
  private userService = inject(SiaUsersService);
  private routerService = inject(SiaNewRouterService);
  private sizeDetectorService = inject(SiaSizeDetectorService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getDefaults(
    dataType: string,
    defaultPatterOrValue: any,
    existingValue?: any,
  ) {
    if (
      defaultPatterOrValue != null &&
      defaultPatterOrValue != undefined &&
      typeof defaultPatterOrValue == 'string' &&
      defaultPatterOrValue[0] != '$'
    ) {
      defaultPatterOrValue = defaultPatterOrValue.toLowerCase();
      if (defaultPatterOrValue[0] == '@') {
        return this.userService
          .getUserDefaultsData()
          ?.find(
            (x) =>
              x.id?.toLowerCase() ==
              defaultPatterOrValue
                .slice(1, defaultPatterOrValue.length)
                .toLowerCase(),
          )?.value;
      }
      switch (dataType?.toLowerCase()) {
        case 'text':
        case 'textarea':
          if (defaultPatterOrValue[0] != '#') {
            return defaultPatterOrValue;
          } else {
            var value =
              this.extractDefaultProperty(defaultPatterOrValue).toLowerCase();
            if (value == 'shortname') {
              return this.userService.getUserData()?.shortName;
            }
            if (value == 'secondaryoutlet') {
              return this.routerService.getLatestRoutingData()?.outlet;
            }
            if (value == 'userlanguage') {
              return this.userService.getUserData()?.languageId;
            }
          }
          break;
        case 'mixed':
          break;
        case 'select':
        case 'radar':
          if (defaultPatterOrValue[0] != '#') {
            return defaultPatterOrValue;
          } else {
            var value = this.extractDefaultProperty(defaultPatterOrValue);
            if (value == 'currentYear') {
              return getYear(new Date());
            }
            if (value == 'userid') {
              return this.userService.getUserData()?.id;
            }
            if (value == 'currentmonth') {
              return getMonth(new Date()) + 1;
            }
            if (value == 'currentyear') {
              return getYear(new Date());
            }
            if (value == 'previousmonth') {
              let date = addMonths(new Date(), -1);
              return getMonth(date) + 1;
            }
            if (value == 'previousmonthyear') {
              let date = addMonths(new Date(), -1);
              return getYear(date);
            }
            if (value == 'previousmonthpreviousyear') {
              let date = addMonths(new Date(), -1);
              return getYear(date) - 1;
            }
            if (value == 'previousyear') {
              var year = getYear(new Date());
              return year - 1;
            }
          }
          break;
        case 'bool':
        case 'boolean':
        case 'check':
        case 'checkbox':
          switch (defaultPatterOrValue) {
            case 'ismobile':
              return this.sizeDetectorService.currentSize.isMobile;
            default:
          }
          return defaultPatterOrValue == 'true';
        case 'time':
          if (!defaultPatterOrValue) return null;
          var time = new Date();
          if (existingValue) {
            time = parseISO(existingValue);
          }
          var timeParts = defaultPatterOrValue.split(':');
          if (!timeParts) return;
          if (timeParts.length != 2) return;

          time.setHours(parseInt(timeParts[0]), 0);
          return time;
        case 'date':
        case 'datetime':
          // console.error("DEFAULT SELECT");
          if (defaultPatterOrValue[0] != '#') {
            return new Date(defaultPatterOrValue);
          } else {
            var value = this.extractDefaultProperty(defaultPatterOrValue);
            if (value == 'today') {
              return new Date();
            }
            if (value == 'todaynumber') {
              return this.dateService.date2number(new Date())?.date;
            }
            if (value == 'startyear') {
              return startOfYear(new Date());
            }
            if (value == 'endyear') {
              return endOfYear(new Date());
            }
            if (value == '12monthstart') {
              let today = new Date();
              if (getDaysInMonth(today) > 5) {
                today = addMonths(today, -11);
                return startOfMonth(today);
              } else {
                today = addMonths(today, -12);
                return startOfMonth(today);
              }
            }
            if (value == 'startyearjanuary') {
              return startOfYear(addMonths(new Date(), -1));
            }
            if (value == '12monthend') {
              let today = new Date();
              if (getDaysInMonth(today) > 5) {
                return endOfMonth(today);
              } else {
                today = addMonths(today, -1);
                return endOfMonth(today);
              }
            }
            if (value == 'startmonth') {
              return startOfMonth(new Date());
            }
            if (value == 'endmonth') {
              return endOfMonth(new Date());
            }
          }
          break;
        case 'number':
          if (defaultPatterOrValue[0] != '#') {
            return Number.parseInt(defaultPatterOrValue);
          } else {
            var value = this.extractDefaultProperty(defaultPatterOrValue);
            if (value == 'userid') {
              // console.log('Risolvo id utente', value);
              return this.userService.getUserData()?.id;
            }
            if (value == 'currentmonth') {
              return getMonth(new Date());
            }
            if (value == 'currentyear') {
              return getYear(new Date());
            }
            if (value == 'previousmonth') {
              let date = addMonths(new Date(), -1);
              return getMonth(date);
            }
            if (value == 'previousmonthyear') {
              let date = addMonths(new Date(), -1);
              return getYear(date);
            }
            if (value == 'previousmonthpreviousyear') {
              let date = addMonths(new Date(), -1);
              return getYear(date) - 1;
            }
            if (value == 'previousyear') {
              var year = getYear(new Date());
              return year - 1;
            }
            if (value == 'userid') {
              return this.userService.getUserData()?.id;
            }
          }
          break;
        case 'radar-multi':
          return null;
        default:
          return null;
      }
    } else if (
      defaultPatterOrValue &&
      typeof defaultPatterOrValue == 'string' &&
      defaultPatterOrValue[0] == '$'
    ) {
      var sessionValue = this.sessionService.getSessionParamValue(
        defaultPatterOrValue.substr(1, defaultPatterOrValue.length - 1),
      );
      return sessionValue;
    }
    return defaultPatterOrValue;
  }

  generateDefault(
    dataType: string,
    defaultPatterOrValue: string | any,
    existingValue?: any,
  ) {
    if (!defaultPatterOrValue || typeof defaultPatterOrValue != 'string') {
      return defaultPatterOrValue;
    }
    var defaultPatterOrValueStr: string = defaultPatterOrValue;
    var complexDefault = defaultPatterOrValueStr.split('+');
    if (!complexDefault || complexDefault.length == 0)
      return defaultPatterOrValue;
    if (complexDefault.length == 1)
      return this.getDefaults(dataType, defaultPatterOrValue, existingValue);
    var res: string = '';
    complexDefault.forEach((element) => {
      res += this.getDefaults(dataType, element);
    });
    return res;
  }

  private extractDefaultProperty(defaultPatterOrValue: string) {
    return defaultPatterOrValue.slice(1, defaultPatterOrValue.length);
  }
  //#region private methods
}
